<template>
  <div id="footer">
    <img src="../assets/img/footer/footer.jpg" alt="menu">
    <div class="copy" @click="toBeiAn">水成科技 版权所有 沪ICP备19022868号-1 沪公网安备 31011002001095号</div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {
    toBeiAn() {
      window.location.href = 'https://beian.miit.gov.cn/';
    }
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  overflow: hidden;
  text-align: center;
}

#footer img {
  width: 100%;
}

.copy {
  background: #474747;
  color: #d3d3d3;
  font-size: 14px;
  padding: 10px;
}

.copy:hover { cursor: pointer; }

@media screen and (max-width: 997px) {
  .copy {
    font-size: 12px;
    padding: 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue